<template>
    <div class="footer">
       <footer class="proFooter">
            <img src="../../assets/img/logo.png" />
            <ul class="proConnect">
                <li>
                    <span>諮詢專線：</span>
                    <label>04-23054567轉4116</label>
                </li>
                <li>
                    <span>信&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</span>
                    <label>keran@digiwin.com</label>
                </li>
                <li>
                    <span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span>
                    <label>台中市大里區東湖里中興路一段161號</label>
                </li>
            </ul>
            <div class="proLink">
                <span>鼎新網頁：</span>
                <ul>
                    <li><a href="https://www.digiwin.com/tw" target="_blank">鼎新數智</a></li>
                    <li><a href="https://market.digiwincloud.com/dw-display/dw-cloud-market" target="_blank">鼎新雲市場</a></li>
                    <li><a href="http://es-ygj.digiwincloud.com/" target="_blank">鼎新雲管家</a></li>
                </ul>
                <div class="clear"></div>
            </div>
            <p>Copyright© 鼎新數智股份有限公司. Copyright © Data Systems Consulting Co., Ltd. All rights reserved.</p>
        </footer>
    </div>
</template>
<script>
  export default {
    name: 'Footer'
  }
</script>



// WEBPACK FOOTER //
// src/components/common/Footer.vue